import config from '../../config';
import supportedDeviceType from './supportedDeviceTypes';

export function detectDevice(headers) {
  let deviceViewer = headers['x-cf-device-type'];
  if (deviceViewer) {
    return detectDeviceByCloudFlare(headers);
  } else {
    return detectDeviceByCloudFront(headers);
  }
}

function detectDeviceByCloudFlare(headers) {
  let deviceType = supportedDeviceType.desktop;
  let deviceViewer = headers['x-cf-device-type'];

  if (deviceViewer) {
    deviceType =
      deviceViewer === 'tablet'
        ? supportedDeviceType.tablet
        : deviceViewer === 'mobile'
          ? supportedDeviceType.mobile
          : supportedDeviceType.desktop;
  } else {
    const userAgent = headers['user-agent'];
    if (userAgent) {
      const isMobileDevice = userAgent.match(config.userAgentForMobile);
      const isTabletDevice = userAgent.match(config.userAgentForTablet);
      deviceType = isTabletDevice
        ? supportedDeviceType.tablet
        : isMobileDevice
          ? supportedDeviceType.mobile
          : supportedDeviceType.desktop;
    }
  }
  return deviceType;
}

function detectDeviceByCloudFront(headers) {
  let deviceType = supportedDeviceType.desktop;
  const desktopViewer = headers['x-cf-desktop-viewer'];
  const mobileViewer = headers['x-cf-mobile-viewer'];
  const tabletViewer = headers['x-cf-tablet-viewer'];

  if (
    desktopViewer !== undefined &&
    mobileViewer !== undefined &&
    tabletViewer !== undefined
  ) {
    deviceType =
      tabletViewer === 'true'
        ? supportedDeviceType.tablet
        : mobileViewer === 'true'
          ? supportedDeviceType.mobile
          : supportedDeviceType.desktop;
  } else {
    const userAgent = headers['user-agent'];
    if (userAgent) {
      const isMobileDevice = userAgent.match(config.userAgentForMobile);
      const isTabletDevice = userAgent.match(config.userAgentForTablet);
      deviceType = isTabletDevice
        ? supportedDeviceType.tablet
        : isMobileDevice
          ? supportedDeviceType.mobile
          : supportedDeviceType.desktop;
    }
  }
  return deviceType;
}

export function checkNextGenSupport(headers) {
  let isNextGenSupported = 'false';
  const cfNextGenSupported = headers['x-nextgen-supported'];

  if (cfNextGenSupported !== undefined) {
    isNextGenSupported = cfNextGenSupported === 'true' ? true : false;
  } else {
    const userAgent = headers['user-agent'];
    isNextGenSupported = userAgent
      ? userAgent.match(config.nextGenSupportedBrowsers)
      : 'false';
  }
  return Boolean(isNextGenSupported);
}
